import {
  CardBody,
  CardTitle,
  Container,
  Card,
  Row,
  Col,
  // CardSubtitle,
  // Button,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  getQuestionRequest,
  getQuizzesRequest,
  sendAnswerRequest,
} from "../../api/controller/PublicQuizController";
import { handleResponse } from "../../custom/helpers/HandleResponse";
import moment from "moment";
import bgImage from "../../assets/images/bg2.jpg";
import { Loader } from "../../custom/components/Loader";
import { logoutRequest } from "../../api/controller/AuthController";
import { useHistory } from "react-router-dom";
import { HasPermission } from '../../custom/helpers/HasPermission'

const Home = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [question, setQuestion] = useState({});
  const [options, setOptions] = useState(null);
  const [answer, setAnswer] = useState({ Question: null, Option: null });
  const [questionDate, setQuestionDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [correctOption, setCorrectOption] = useState(null);
  const [myAnswer, setMyAnswer] = useState(null);
  const [loading, setLoading] = useState(false);

  const logout = async() => {
    const response = await logoutRequest()
    if(response){
        localStorage.removeItem('authToken')
        window.location.replace("/");
    }
  }

  const getQuestion = async (date) => {
    if (activeQuiz?.id) {
      if(moment(activeQuiz.end_date).isSameOrAfter(moment(date))){
        setLoading(true);
        const response = await getQuestionRequest({
          Quiz: activeQuiz?.id,
          Date: date,
        });
        if (response.Status) {
          handleResponse(response);
        } else {
          setQuestion(response.data);
        }
        setLoading(false);
      } else {
        setQuestionDate(activeQuiz.end_date);
      }
    }
  };

  const submitAnswer = async () => {
    if (activeQuiz?.id) {
      setLoading(true);
      const response = await sendAnswerRequest(answer);
      if (response.Status) {
        handleResponse(response);
        setActiveQuiz(null);
      } else {
        setActiveQuiz(null);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    async function getData() {
      const response = await getQuizzesRequest();
      if (response.Status) {
        handleResponse(response);
      } else {
        setQuizzes(response.data);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    // getQuestion(moment().format("YYYY-MM-DD"));
    setQuestionDate((moment(activeQuiz?.end_date).isBefore(moment()) ? moment(activeQuiz?.end_date) : moment()).format("YYYY-MM-DD"));
    return () => {
      setQuestion({})
      setOptions(null)
      setAnswer({ Question: null, Option: null })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeQuiz]);

  useEffect(() => {
    setOptions(question.options);
    if (question.my_answer) {
      setMyAnswer(question.my_answer);
    } else {
      setMyAnswer(null);
    }
    if (question.correct_option) {
      setCorrectOption(question.correct_option);
    } else {
      setCorrectOption(null);
    }
  }, [question]);

  useEffect(() => {
    getQuestion(questionDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeQuiz, questionDate]);

  // useEffect(() => {
  //   getQuestion(questionDate);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [questionDate]);

  const handleSelectQuiz = (quizId) => {
    setActiveQuiz(quizId);
  };

  const handleGotoMain = () => {
    setActiveQuiz(null);
    setQuestion({});
    setOptions(null);
    setAnswer({ Question: null, Option: null });
    setQuestionDate(moment().format("YYYY-MM-DD"));
  };

  const handleShowPrevious = () => {
    setQuestionDate(
      moment(questionDate).subtract(1, "days").format("YYYY-MM-DD")
    );
  };

  const handleShowNext = () => {
    setQuestionDate(moment(questionDate).add(1, "days").format("YYYY-MM-DD"));
  };

  const handleSubmitAnswer = () => {
    submitAnswer();
  };

  const history = useHistory();

  return (
    <React.Fragment>
      <div>
        <img
          src={bgImage}
          alt=""
          style={{
            width: "100%",
            height: "100vh",
            backgroundSize: "cover",
            zIndex: "-10",
            position: "absolute",
            opacity: 1,
            objectFit: "cover",
          }}
        />
        <button style={{position: 'absolute', right: '5px', top: '5px', zIndex: 9999}} className='btn btn-warning' onClick={() => logout()}>Logout</button>
        {HasPermission(":read-quizes") ? (
          <button style={{position: 'absolute', left: '5px', top: '5px', zIndex: 9999}} className='btn btn-primary' onClick={() => history.push('/quizes')}>Admin</button>
        ) : null}
      </div>
      <div style={{height: "100vh", overflowY: "scroll"}}>
        <Loader loading={loading} transparent />
        <Container style={{paddingTop:'80px'}}>
          {activeQuiz !== null ? (
            <Row className="row justify-content-md-center pb-3">
              <Col className="col-md-6 ">
                <Row>
                  <Col>
                    <button
                      className="btn btn-light"
                      onClick={() => handleGotoMain()}
                    >
                      <span className="fs-3 faruma">
                        <span className="mdi mdi-arrow-left-bold">
                          {" "}
                          ކުއިޒް މެނޫ{" "}
                        </span>
                      </span>
                    </button>
                  </Col>
                  <Col
                    className="col-md-6 text-right"
                    style={{ direction: "rtl" }}
                  >
                    <Row>
                      <span className="fs-3 text-light">
                        {moment(questionDate).format("LL")}
                      </span>
                    </Row>
                    <Row>
                      <span className="fs-3 text-light faruma">{question.name}</span>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : null}

          {activeQuiz === null ? (
            <div>
              {quizzes.map((item, key) => {
                return (
                  <div key={key}>
                    <Row className="row justify-content-md-center">
                      <Col className="col-md-6">
                        <Card
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelectQuiz(item)}
                        >
                          <CardBody>
                            <CardTitle className="faruma fs-1">
                              {item.name}
                            </CardTitle>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <Row className="row justify-content-md-center">
                <Col className="col-md-6">
                  <Row className="mb-3">
                    <Col className="col-md-6">
                      {question.is_next_day_visible === true ? (
                        <button
                          className="btn btn-primary w-100 faruma fs-3"
                          onClick={() => handleShowNext()}
                        >
                          ކުރިއަށް
                          &nbsp;<span className="mdi mdi-chevron-left"></span>
                        </button>
                      ) : (
                        <button
                          className="btn btn-secondary w-100 faruma fs-3"
                          disabled
                        >
                          ކުރިއަށް
                          &nbsp;<span className="mdi mdi-chevron-left"></span>
                        </button>
                      )}
                    </Col>
                    <Col className="col-md-6">
                      {question.is_prev_day_visible === true ? (
                        <button
                          className="btn btn-primary w-100 faruma fs-3"
                          onClick={() => handleShowPrevious()}
                        >
                          <span className="mdi mdi-chevron-right"></span>&nbsp;
                          ފަހަތަށް
                        </button>
                      ) : (
                        <button
                          className="btn btn-secondary w-100 faruma fs-3"
                          disabled
                        >
                          <span className="mdi mdi-chevron-right"></span>&nbsp;
                          ފަހަތަށް
                        </button>
                      )}
                    </Col>
                  </Row>
                  <Card>
                    <CardBody>
                      <CardTitle className="faruma fs-1 text-center">
                        {activeQuiz.name}
                      </CardTitle>
                      {activeQuiz.question_type === "Text" ? (
                        <div>
                          <div className="faruma text-muted fs-2 mt-5 text-center">
                            {question.description}
                          </div>
                        </div>
                      ) : activeQuiz.question_type === "Image" ? (
                        <React.Fragment>
                          {question.description ? (
                            <div>
                              <div className="faruma text-muted fs-2 mb-3 text-center">
                                {question.description}
                              </div>
                            </div>
                          ) : null}
                          <div className="w-100">
                            {question.can_view_correct_answer === true && question.correct_image ? (
                              <img
                                src={
                                  process.env.REACT_APP_STORAGE_URL +
                                  question.correct_image
                                }
                                alt="question"
                                className="img-fluid w-100"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            ) : (
                                question?.image && (
                                  <img
                                    src={
                                      process.env.REACT_APP_STORAGE_URL +
                                      question.image
                                    }
                                    alt="question"
                                    className="img-fluid w-100"
                                    onError={(e) => (e.target.style.display = "none")}
                                  />
                                )
                            )}
                          </div>
                        </React.Fragment>
                      ) : (
                        <div></div>
                      )}

                      {correctOption?.id ? (
                        <Row className="mt-4">
                          <Col className="col-md-12">
                            <div className="alert alert-success faruma fs-2 mb-0">
                              <span>ރަނގަޅު ޖަވާބު: </span>
                              <span className="">
                                {correctOption.description}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      ) : null}
                      {options
                        ? options.map((item, key) => {
                            return (
                              <div key={key}>
                                <Row>
                                  <Col className="faruma text-muted fs-2 mt-5">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="options"
                                      id={"option" + item.id}
                                      value={item.id}
                                      onChange={() =>
                                        setAnswer({
                                          Question: item.question_id,
                                          Option: item.id,
                                        })
                                      }
                                      checked={myAnswer?.question_option_id ? (myAnswer?.question_option_id === item.id) : (answer.Option ? answer.Option === item.id : false)}
                                      disabled={!question.is_answerable}
                                    />

                                    {question?.is_correct === false &&
                                    myAnswer?.question_option_id === item.id ? (
                                      <span className="text-danger p-3">
                                        {item.description}
                                      </span>
                                    ) : question?.is_correct === true &&
                                      myAnswer?.question_option_id ===
                                        item.id ? (
                                      <span className="text-success p-3">
                                        {item.description}
                                      </span>
                                    ) : (
                                      <span> {item.description}</span>
                                    )}

                                    {/* <span className={`alert ${myAnswer?.id !== item.id ? "alert-info" : null}`}> {item.description}</span>
                                    <span className={`alert ${myAnswer?.id !== item.id ? "alert-info" : null}`}> {item.description}</span> */}
                                    {/* <span className={'alert '+ myAnswer?.id != item.id ? "alert-info" : null}> {item.description}</span> */}
                                  </Col>
                                </Row>
                              </div>
                            );
                          })
                        : null}
                      {question.is_answerable ? (
                        <Row className="mt-5">
                          <Col className="col-md-12">
                            <button
                              className="btn btn-primary w-100 fs-2"
                              type="button"
                              onClick={() => handleSubmitAnswer()}
                            >
                              <span className="faruma">ސަބްމިޓް</span>
                            </button>
                          </Col>
                        </Row>
                      ) : null}
                      <br />
                      {question.has_winners ? (
                        question.events.map((item, key) => (
                          <Row key={key} className="mt-3">
                            <Col className="col-md-12">
                              <div className="alert alert-primary fs-2 mb-0">
                                <div className="faruma">
                                  <span>{item.name}: </span>
                                </div>
                                <div style={{textAlign: 'left'}}>
                                  {item.winners.map((winner, key) => (
                                    <>
                                      <span key={key} className="mx-2" style={{fontFamily:'Arial',fontSize:"18px"}}>- {winner.name} ({winner.rcno}) [ {winner.section} ]</span>
                                      <br />
                                    </>
                                  ))}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ))
                      ) : null}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Home;
